'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _store = require('../store');

var _store2 = _interopRequireDefault(_store);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  store: _store2.default,
  data: function data() {
    return {
      'question': {}
    };
  },

  props: ['isSimulation', 'questionId', 'categoryId', 'questionCommentTitle', 'questionCommentTooltip'],
  mounted: function mounted() {
    var payload = {
      questionId: this.questionId,
      categoryId: this.categoryId
    };

    var self = this;

    var promise = this.getQuestion(payload);

    promise.then(function (result) {
      self.question = result;
    }).catch(function (error) {
      console.error(error);
    });
  },

  computed: _extends({}, (0, _vuex.mapGetters)(['getQuestionResults', 'getAnswers']), {
    displayQuestion: function displayQuestion() {
      return this.question.display;
    },
    questionClass: function questionClass() {
      return [{ 'question--hidden': this.question.display === false }, { 'question--simulation': this.isSimulation === true }, { 'question--invalid': this.question.valid === false }, { 'gr-12': this.question.styleClass === '' || this.question.styleClass === undefined }, this.question.styleClass];
    },
    scoreExplanation: function scoreExplanation() {
      if (this.question) {
        var text = '';
        text += 'Apply penalty if question is skipped: ';
        text += this.question.applyPenaltyIfSkipped ? 'yes' : 'no';
        text += '<br>Penalty: ' + this.question.penalty + '<br>';
        if (this.question.requiredForSiteSecurityClassifications) {
          text += 'Required for SSC: ' + this.question.requiredForSiteSecurityClassifications.join(', ') + '<br>';
        }

        if (this.question.automaticRiskLevel && this.question.automaticRiskLevel.length > 0) {
          text += 'Automatic risk level: ' + this.question.automaticRiskLevel + '<br>';
        }
        if (this.question.automaticRiskLevelForRiskCountry && this.question.automaticRiskLevelForRiskCountry.length > 0) {
          text += 'Automatic risk level for country: ' + this.question.automaticRiskLevelForRiskCountry + '<br>';
        }
        if (this.question.questionConditionGroups && this.question.questionConditionGroups.length > 0) {
          text += 'Question condition maingroup type: ' + this.question.questionConditionMainGroupType + '<br>';
          text += '<b>Question Condition Groups:</b><br>';
          this.question.questionConditionGroups.forEach(function (questionConditionGroup) {
            if (questionConditionGroup && questionConditionGroup.conditions && questionConditionGroup.conditions.length > 0) {
              text += '&nbsp; Type: ' + questionConditionGroup.questionConditionGroupType + '<br>';
              text += '&nbsp; &nbsp; ' + 'Conditions: <br>';
              questionConditionGroup.conditions.forEach(function (condition) {
                text += '&nbsp; &nbsp; - ' + condition + '<br>';
              });
            }
          });
        }
        return text;
      }
    }
  }),
  methods: _extends({}, (0, _vuex.mapActions)(['getQuestion']))
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./public/js/components/question.vue
// module id = ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./public/js/components/question.vue
// module chunks = 0